<template lang="pug">
div.sidebar-banner__content
  div.sidebar-banner__content-live-now--embeded(v-html='value.embedded_tag')
  div.sidebar-banner__content-live-now--text
    a.sidebar-banner__content-live-now--link(:href="value.facebook_url", target="_blank")
      div.sidebar-banner__content-live-now--time
        span.sidebar-banner__content-live-now--time--live Live配信中
        Fragment {{value.start_date | modifyStartTime}}{{value.end_date | modifyEndTime}}
      p.sidebar-banner__content-live-now--title {{value.title}}
      p.sidebar-banner__content-live-now--company-name {{value.company_name}}
</template>

<script>
import { getPeriodStartTime, getPeriodEndTime } from './../../utilities/modifyTime';

export default {
  name: 'AddLiveBannerElement',
  props: {
    valueProps: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    value: {
      get () {
        return this.valueProps;
      },
      set (newValue) {
        this.$emit('update:valueProps', newValue);
      }
    }
  },
  filters: {
    modifyStartTime: function (time) {
      const periodTime = getPeriodStartTime(time);
      return `${periodTime.startDate} ${periodTime.startDay} ${periodTime.startTime}`;
    },
    modifyEndTime: function (time) {
      return ` 〜 ${getPeriodEndTime(time)}`;
    }
  }
};
</script>
